import { render } from "./PrintFoodHygieneLicence.vue?vue&type=template&id=65bb3bb2&scoped=true"
import script from "./PrintFoodHygieneLicence.vue?vue&type=script&lang=js"
export * from "./PrintFoodHygieneLicence.vue?vue&type=script&lang=js"

import "./PrintFoodHygieneLicence.vue?vue&type=style&index=0&id=65bb3bb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65bb3bb2"]])

export default __exports__